import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  Paper,
  Button,
  Typography,
} from '@material-ui/core';
import styles from './styles';

export const ConfirmEmailPageComponent = ({ classes }) => (
  <div className={classes.container}>
    <div className={classes.content}>
      <Paper className={classes.root} elevation={10}>
        <Typography variant="h3">
          Please confirm your email address.
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          Please check your email inbox for a message asking you to confirm your email address.
        </Typography>
        <Typography variant="body2" gutterBottom>
          If you cannot find your confirmation email, please&nbsp;
          <a
            href="mailto:support@pingum.io?Subject=Email%20Verification%20Help"
            target="_top"
          >
            contact support
          </a>.
        </Typography>
        <Typography variant="body2" gutterBottom>
          <div className={classes.buttonContainer}>
            <div>Already confirmed your email?</div>
            <Button
              className={classes.button}
              color="secondary"
              size="small"
              href="/login"
              variant="contained"
            >
              Login
            </Button>
          </div>
        </Typography>
      </Paper>
    </div>
  </div>
);

ConfirmEmailPageComponent.propTypes = { classes: PropTypes.object };
ConfirmEmailPageComponent.defaultProps = { classes: {} };

export default withStyles(styles, { withTheme: true })(ConfirmEmailPageComponent);
